import React from 'react';
import Loadable from 'jaybe-react-loadable';

import ClientPage from '../../context/clientPage';
import ClientInfo from '../../context/clientInfo';
import ClientConfig from '../../context/clientConfig';

import PinNoField from './fields/pinNoField';
import CardNoField from './fields/cardNoField';
import FormError from './formError';
import Results from '../results';
import SubmitButton from '../submitBtn';
import LoadingSpinner from '../loadingSpinner';

const Recaptcha = Loadable({
  loader: () => import('../recaptcha'),
  loading: () => null,
});

const WBIForm = ({ passedComponent }) => (
  <ClientConfig.Consumer>
    {clientConfig => {
      const {
        captchaLabelText,
        cardLength,
        customNS,
        labelClassNames,
        prefixConfig,
        paddingConfig,
        pinLength,
        pinType,
        pinTruncate,
        showEnhancedResults,
        showCardEOV,
        showTimeZone,
        showTransactionTime,
        spinnerOrder,
        formExtraComponent,
        langOverride,
        formatCardNum,
        showSeperateResultsView,
        seperateResultsMessage,
        seperateResultsMessageURL,
        seperateResultsMessageRowClass,
        seperateResConfirmButton,
      } = clientConfig;

      return (
        <ClientInfo.Consumer>
          {({ clientInfo }) => {
            const { showPin, showCaptcha } = clientInfo;
            const language = langOverride || clientInfo.language;
            const captchaSize = showCaptcha === 2 ? 'invisible' : 'normal';
            
            return (
              <ClientPage.Consumer>
                {({ pageData, actions }) => {
                  const { showError, showResults, loadingResults } = pageData;
                  const { handleUpdateCardConfig, handleUpdatePinConfig, handleToggle } = actions;

                  // If configured, results will show in seperate view
                  if (showResults && showSeperateResultsView) {
                    return (
                      <div id='seperateResultsCol' className='flex-column'>
                        <div className={`d-flex flex-row ${seperateResultsMessageRowClass}`}>
                          <a href={seperateResultsMessageURL}>{seperateResultsMessage}</a>
                        </div>
                        <div className='d-flex flex-row seperate-res-row'>
                          <Results
                            showEnhancedResults={showEnhancedResults}
                            showCardEOV={showCardEOV}
                            showTransactionTime={showTransactionTime}
                            showTimeZone={showTimeZone}
                            handleToggle={handleToggle}
                            language={language}
                          />
                        </div>
                        <div id='seperateResultsBtnDiv' className='d-flex flex-row'>
                          {seperateResConfirmButton}
                        </div>
                      </div>

                    );
                  }
                  return (
                    <>
                      <form className='form-group'>
                        <div id='wbiForm' className='d-row'>
                          {passedComponent}
                          {showError && <FormError />}
                          <div id='cardNoDiv'>
                            <CardNoField
                              cardLength={cardLength}
                              prefixConfig={prefixConfig}
                              paddingConfig={paddingConfig}
                              handleUpdateCardConfig={handleUpdateCardConfig}
                              formatCardNum={formatCardNum}
                            />
                          </div>
                          <div id='pinDiv'>
                            {showPin && <PinNoField pinLength={pinLength} pinType={pinType} pinTruncate={pinTruncate} handleUpdatePinConfig={handleUpdatePinConfig} />}
                          </div>
                          <div id='captchaDiv' className={`cap-${captchaSize}`}>
                            {!!showCaptcha && showCaptcha !== 3 && <Recaptcha size={captchaSize} customNS={customNS} labelText={captchaLabelText} labelClassNames={labelClassNames} />}
                          </div>
                          <div id='sbtnDiv'>
                            <SubmitButton />
                          </div>
                          {formExtraComponent}
                          {loadingResults && <LoadingSpinner order={spinnerOrder} />}
                          {showResults && (
                            <Results
                              showEnhancedResults={showEnhancedResults}
                              showCardEOV={showCardEOV}
                              showTransactionTime={showTransactionTime}
                              showTimeZone={showTimeZone}
                              handleToggle={handleToggle}
                              language={language}
                            />
                          )}
                        </div>
                      </form>
                    </>
                  );
                }}
              </ClientPage.Consumer>
            );
          }}
        </ClientInfo.Consumer>
      );
    }}
  </ClientConfig.Consumer>
);

export default WBIForm;
